module.exports = __webpack_public_path__ + "img/teacher_2.5c7366fa.png";